module.exports = __webpack_public_path__ + "img/farm-fresh.2e2eaa1b.jpg";